(() => {
  if (window.__cContentBlockInitialized) return;
  window.__cContentBlockInitialized = true;

  const init = () => {
    const contents = Array.from(document.querySelectorAll('.c_content-block__content'));
    if (!contents.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reducedMotion) {
      contents.forEach((el) => el.classList.add('-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    contents.forEach((el) => observer.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
